import { fromJS } from 'immutable';
import createAction from 'utils/redux-helpers/createAction';

const handler = (state, { data }) => state.mergeIn(['user'], fromJS(data));

export const setDriverInfo = createAction({
  action: ['setDriverInfo', 'data'],
  handler,
});
